import { Instance } from 'mobx-state-tree';
import { WebhookDtoModelBase } from './WebhookDtoModel.base';

/* The TypeScript type of an instance of WebhookDtoModel */
export interface WebhookDtoModelType extends Instance<typeof WebhookDtoModel.Type> {}

/* A graphql query fragment builders for WebhookDtoModel */
export { selectFromWebhookDto, webhookDtoModelPrimitives, WebhookDtoModelSelector } from './WebhookDtoModel.base';

/**
 * WebhookDtoModel
 */
export const WebhookDtoModel = WebhookDtoModelBase
  .actions(self => ({
    setActive(active: boolean) {
      self.active = active;
    },
  }));
